import React from "react";
import { TranslationSteps } from "~/Common/TranslationConstant";
import { TS } from "~/Services/TS";

export function TranslationAction({
    currentStep,
    isDisableContinue,
    isShowSaveButton,
    isDisableNextButton,
    isDisableSaveButton,
    handleCloseModal,
    onHandleContinue,
    onNextButton,
    onBackButton,
    onSaveButton,
}: {
    currentStep: string;
    isDisableContinue: boolean;
    isShowSaveButton: boolean;
    isDisableNextButton: boolean;
    isDisableSaveButton: boolean;
    handleCloseModal: () => void;
    onHandleContinue: () => void;
    onNextButton: () => void;
    onBackButton: () => void;
    onSaveButton: () => void;
}) {
    return (
        <div>
            <button className="button tertiary" onClick={handleCloseModal}>
                {TS("Cancel")}
            </button>
            {currentStep === TranslationSteps.CHOOSE_LANGUAGE && (
                <button disabled={isDisableContinue} className="button" onClick={onHandleContinue}>
                    {TS("Continue")}
                </button>
            )}
            {currentStep === TranslationSteps.EDIT_TRANSLATION && (
                <>
                    <button className="button tertiary" onClick={onBackButton}>
                        {TS("Back")}
                    </button>
                    {!isShowSaveButton ? (
                        <button disabled={isDisableNextButton} className="button tertiary" onClick={onNextButton}>
                            {TS("Next")}
                        </button>
                    ) : (
                        <button className="button" disabled={isDisableSaveButton} onClick={onSaveButton}>
                            {TS("Save")}
                        </button>
                    )}
                </>
            )}
        </div>
    );
}
